import { Fragment } from 'react';
import { Carousel, GenericLink } from '@nextgen-web-framework/all';
import FeaturedCard from './FeaturedCard';
import { FeaturedCardsProps, FeaturedCard as FeaturedCardProps } from './types/propsTypes';
import styles from './FeaturedCardContainer.module.scss';
const FeaturedCardContainer = (props: FeaturedCardsProps) => {
  const featuredCards = props;
  const featuredCardsList = featuredCards.featuredCradsList || [];
  return (
    <div className={`${styles['featured-container']}`} data-testid="featured-cards-test-id">
      <div className={styles['featured-header-container']}>
        <h2 className={styles['featured-header-title']}>{featuredCards.heading}</h2>
        {featuredCards.viewAllLink?.title && (
          <div className={styles['featured-header-view-all']}>
            <GenericLink
              href={featuredCards.viewAllLink.href}
              forceNative={false}
              target={featuredCards.viewAllLink.target}
            >
              {featuredCards.viewAllLink.title}
            </GenericLink>
          </div>
        )}
      </div>

      <div className={styles['featured-card-container']}>
        <Carousel id={'Feature-Card-Carousel'} isTileCarousel={true}>
          {featuredCardsList.map((card: FeaturedCardProps) => (
            <Fragment key={card.heading}>
              <FeaturedCard {...card} />
            </Fragment>
          ))}
        </Carousel>
      </div>
    </div>
  );
};

export default FeaturedCardContainer;
